import React from 'react';
import { ChevronRight } from 'lucide-react';

interface NewsArticle {
  id: number;
  category: string;
  date: string;
  title: string;
  description: string;
  image: string;
  featured: boolean;
}

const newsArticles: NewsArticle[] = [
  {
    id: 1,
    category: "Platform & Campsite Updates",
    date: "2025.10.07",
    title: "New Trails Unlocked: Explore Two Fresh Campsites Near Plover Cove!",
    description: "Two new hiking and camping trails are now open with improved facilities and monitoring systems.",
    image: "https://placehold.co/600x400/e2e8f0/64748b?text=Camping+Trail",
    featured: true
  },
  {
    id: 2,
    category: "WordPress",
    date: "2025.10.06",
    title: "Eco-Friendly Camping: Small Habits, Big Impact",
    description: "",
    image: "https://placehold.co/600x400/e2e8f0/64748b?text=Eco+Camping",
    featured: false
  },
  {
    id: 3,
    category: "Inspiration & Lifestyle",
    date: "2025.10.03",
    title: "Weekend Escape: The Best Forest Trails Around Lau Shui Heung",
    description: "",
    image: "https://placehold.co/600x400/e2e8f0/64748b?text=Forest+Trails",
    featured: false
  },
  {
    id: 4,
    category: "Nature & Safety Alerts",
    date: "2025.09.30",
    title: "Wildlife Alert at Bride's Pool Area",
    description: "",
    image: "https://placehold.co/600x400/e2e8f0/64748b?text=Wildlife+Alert",
    featured: false
  }
];

export const FeaturedNews: React.FC = () => {
  const featuredArticle = newsArticles.find(article => article.featured);
  const sideArticles = newsArticles.filter(article => !article.featured);

  return (
    <div className="px-4 sm:px-8 lg:px-16 xl:px-24 pb-12">
      <h2
        className="mb-6"
        style={{
          fontFamily: 'Poppins',
          fontSize: '32px',
          fontWeight: 700,
          color: '#000000'
        }}
      >
        Featured News
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left: Large Featured Article */}
        {featuredArticle && (
          <div className="rounded-2xl overflow-hidden bg-white">
            <div className="relative h-96">
              <img
                src={featuredArticle.image}
                alt={featuredArticle.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <span
                  className="px-4 py-1 bg-black rounded-full"
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '12px',
                    fontWeight: 500,
                    color: '#FFFFFF'
                  }}
                >
                  {featuredArticle.category}
                </span>
                <span
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#667479'
                  }}
                >
                  {featuredArticle.date}
                </span>
              </div>
              <h3
                className="mb-3"
                style={{
                  fontFamily: 'Poppins',
                  fontSize: '24px',
                  fontWeight: 700,
                  lineHeight: '32px',
                  color: '#000000'
                }}
              >
                {featuredArticle.title}
              </h3>
              <p
                className="mb-4"
                style={{
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  color: '#667479'
                }}
              >
                {featuredArticle.description}
              </p>
              <button
                className="flex items-center gap-2"
                style={{
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#000000'
                }}
              >
                Read more
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        )}

        {/* Right: Smaller Articles */}
        <div className="space-y-6">
          {sideArticles.map((article) => (
            <div key={article.id} className="rounded-2xl overflow-hidden bg-white flex gap-4">
              <div className="relative w-64 h-48 flex-shrink-0">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
              <div className="flex-1 py-4">
                <div className="flex items-center gap-3 mb-2">
                  <span
                    className="px-3 py-1 bg-black rounded-full"
                    style={{
                      fontFamily: 'Inter',
                      fontSize: '11px',
                      fontWeight: 500,
                      color: '#FFFFFF'
                    }}
                  >
                    {article.category}
                  </span>
                  <span
                    style={{
                      fontFamily: 'Inter',
                      fontSize: '12px',
                      fontWeight: 400,
                      color: '#667479'
                    }}
                  >
                    {article.date}
                  </span>
                </div>
                <h3
                  className="mb-3"
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '18px',
                    fontWeight: 700,
                    lineHeight: '24px',
                    color: '#000000'
                  }}
                >
                  {article.title}
                </h3>
                <button
                  className="flex items-center gap-2"
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#000000'
                  }}
                >
                  Read more
                  <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
